import React from "react";
import BuyerProfile from "./BuyerProfile";
import SupplierProfile from "./SupplierProfile";
import config from "../../config";
import TransporterProfile from "./TransporterProfile";

export default function Profile() {
  const user = config.user;
  return (
    <>
      {/**Rendering the profile dashboard based on their type */}
      {user.type === "transporter" ? (
        <TransporterProfile />
      ) : user.type === "seller" ? (
        <SupplierProfile />
      ) : (
        <BuyerProfile />
      )}
    </>
  );
}
